import { Injectable, ApplicationRef, OnInit } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { VehicleInfoService } from './vehicle-info.service';
import { CommonDataService } from "../services/common-data.service";
import { SortingService } from "../services/sorting.service";
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Subscription } from 'rxjs/Subscription';
import * as CryptoJS from 'crypto-js';
import {
    Data
} from '../services/data';
import { Utils } from '../shared/utils';
import * as _ from 'lodash';
import { TokenEncrption } from './encryption-File.service';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/take';
// import { HttpHandler, HttpHeaders } from '@angular/common/http';

@Injectable()
export class DataLoaderService {
    public requestOptions:any;
    public headerOptions:any;

    public data: any;
    public dataLang: any;
    public validateData: any;
    public amendInternalCodes = [];
    public hiddenCodes = [];
    public hiddenOptionCodes = [];
    public hiddenOptionsList = [];
    public vehicleInfo: any;
    public getOtherCodeConfig: any;
    public savedConfig: any;
    public baseUrl: string;
    public path: string;
    public addedCodes: any;
    public deletedCodes: any;
    public updateCodes: any;
    public addedMsgs: any;
    public deletedMsgs: any;
    public internalCodes: any;
    public hiddenCodesValidationRes: any;
    public gccInitialInternalCodes: any;
    public gccInitialHiddenOptions: any;
    public gccPreviousHiddenOptions: any;
    public gccInternalCodes: any;
    public gccUpdatedPrices: any;
    public amendUpdatedPrices: any;
    public gccInternalCodesAccept: any;
    public ppmInternalCodesAccept: any;
    public errorMessage: any;
    public hiddenOptions: any;
    public ppmInitialHiddenOptions: any;
    public ppmInitialInternalOptions: any;
    public configurationIdAmendment:any;
    public lang: any;
    public props: any;
    //temp code
    public rimTemp: any;
    public trimTemp: any;
    public amendOtherCodes = [];
    public subscription: Subscription;
    public expAdd = [];
    public expertRemovedCodes = [];
    public expRemoved = [];
    public expertAddedCodes = [];
    public expAddedOnClose = [];
    public expRemovedOnClose = [];
    public otheroptionsCode = [];
    public previousData: any;
    public selectedAddColor: Data;
    public previousExpertRim = [];
    public previousExpertColor = [];
    public previousExpertAddColor = [];
    public previousExpertUpholstery = [];
    public previousColorExp: any;
    public previousAddColorExp: any;
    public previousUpholsteryExp: any;
    public previousRimExp: any;
    public previousTrimExp: any;
    public previousFactoryExp: any;
    public previousLocalExp: any;
    public previousLocalPackagesExp: any;
    public previousPackagesExp: any;
    public validAuthToken: boolean;
    public intialConfigurationId:any
    public storeInitialConfigurationID:any
    public parturl:any;
    public encryptedToken:any;
    public flagDictionary = {
        'dataFlag': false, 'modeFlag': 'normal', 'expertValidateFlag': false, 'migrationFlag': false, 'initialAlternateFlag': false, 'displayInitialAlternative': false,
        'alternateFlag': false, 'loadingFlag': false, 'expertFlag': false, 'errorFlag': false, 'exceptionFlag': false, 'summaryFlag': false,
        'successFlag': false, 'expertSuccessFlag': false, 'openExpertValidateFlag': false,
        'normalSummaryValidFlag': false, 'expertSummaryValidFlag': false, 'expertSummaryFlag': false,
        'expertResetFlag': false, 'alternateOverlayFlag': true, 'specialErrorFlag': false,
        'alternateValidateFlag': false, 'alternateErrorFlag': false, 'specialResetFlag': false, 'summaryValidate': false,
        'confirmValidateFlag': false, 'specialSuccessFlag': false, 'specialCancelFlag': false, 'viewMoreFlag': false, 'factoryFlag': false, 'localFlag': false, 'packageFlag': false,
        'validated': true, 'expertvalidated': true, 'hidePriceForTW': true, 'hideLocalOptForSA': false, 'hidePriceForJP': true, 'currencyFlagJP': false, 'hideTdForAUNZ': true, 'hideTdForAUNZSO': true,
        'noColorOptions': false, 'noAdditionalColor': false, 'noRimOptions': false, 'noTrimOptions': false, 'noupholsteryOptions': false,
        'noLocalOptions': true, 'noPackagesOptions': false, 'noFacOptions': false, 'testFlag': false, 'closeFlag': false, 'expertCancelFlag': false, 'nullFlag': false, 'resetColorFlag': false, 'resetUpholsteryFlag': false,
        'resetRimFlag': false, 'resetTrimFlag': false, 'resetFactoryFlag': false, 'resetLocalOptionsFlag': false, 'resetPackageOptionsFlag': false, 'defaultColorFlag': false, 'defaultAddColorFlag': false, 'defaultUpholsteryFlag': false,
        'defaultRimFlag': false, 'defaultTrimFlag': false, 'defaultFactoryFlag': false, 'defaultLocalOptionsFlag': false, 'defaultPackageOptionsFlag': false,
        'resetAddColorFlag': false, 'normalSummary': false, 'normalSummaryFlag': false, 'normalValidSummary': false, 'hideTdForCA': true, 'hidePriceForMX': true, 'hideTdForMX': true, 'hideTdForEG': true,
        'undoActivated': false, 'undoActivatedForColor': false, 'undoActivatedForAddColor': false, 'undoActivatedForUpholstery': false,
        'undoActivatedForRim': false, 'undoActivatedForTrim': false, 'undoActivatedForFactory': false,
        'undoActivatedForLocal': false, 'undoActivatedForLocalPackages': false, 'undoActivatedForPackages': false, 'noAlternateInExpertMode': true
    }
    public currentDate: string = this.vehicleInfoService.getCurrentDate();
    public alreadyAddedExpertCodes = [];
    public allPackageOptions: any;
    configurationId: any;
    constructor(private _http: Http, private vehicleInfoService: VehicleInfoService,
        private commonDataService: CommonDataService, private sortingService: SortingService, private cdr: ApplicationRef, private tokenEncrption:TokenEncrption ) { 

this.vehicleInfo = this.vehicleInfoService.extractData();
        this.encryptedToken =   tokenEncrption.getencryptedToken();
        console.log("this.encryptedToken---->",this.encryptedToken);
        
		
        const headerOptions = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization-Token': this.encryptedToken,
        }
         this.requestOptions = {
            headers: new Headers(headerOptions)
        };        
        this.postAuthBearerToken();
        this.subscription = this.commonDataService.notifyObservableLanguage$.subscribe((lang) => {
            this.lang = lang.data; 
        });

    }

    // changes for DFE - security fix @Niket
    postAuthBearerToken() {
    
        // if (!(this.vehicleInfo.hookURL.includes('sapevent:CFG'))) {
        if (!(this.vehicleInfo.hookURL.includes('sapevent:CFG'))) {
            const headerOptions = {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': this.vehicleInfo.authToken
            }

            let url = this.vehicleInfo.hookURL;
            console.log("url from DFE", url);
            const requestOptions = {
                headers: new Headers(headerOptions)
            };
            this.parturl = url.substr(0, url.indexOf('orders'));
            this._http.get(this.parturl + 'orders/configurator/validateToken', requestOptions)
                .map(response => response.toString())
                .subscribe(
                    (data) => {
                        const responseData = JSON.stringify(data);
                        this.validAuthToken = true;
                        this.getBaseUrl();    
                    },
                    err => {
                        if (err.status === 401) {
                            this.validAuthToken = false;
                            this.flagDictionary.errorFlag=true;
                            this.flagDictionary.exceptionFlag=true;
                            this.errorMessage = "An unknown technical problem with the Configurator interface occurred."
                        } else {
                            this.validAuthToken = false;
                            this.flagDictionary.errorFlag=true;
                            this.flagDictionary.exceptionFlag=true;
                            this.errorMessage = "An unknown technical problem with the Configurator interface occurred."
                        }
                    }
                );
        }
        else{
            this.getBaseUrl(); 
            
        }
    }

    getSavedConfig() {

        this.savedConfig = {
            "internalCodes": []
        }
        if (this.vehicleInfo.urlFlag == '2' || this.vehicleInfo.urlFlag == '3') {
            let value = (this.vehicleInfo.savedConfig);

            if ((JSON.parse(value).internalCodes != undefined) && (JSON.parse(value).internalCodes != null)) {
                JSON.parse(value).internalCodes.forEach(element => {
                    this.savedConfig.internalCodes.push(element);
                });
            }
        }
        // for (let i in this.savedConfig.internalCodes) {
        //     this.amendInternalCodes.push(this.savedConfig.internalCodes[i]);
        // }
        for (let i in this.data.internalOptions) {
            this.amendInternalCodes.push(this.data.internalOptions[i]);
        }
        this.amendInternalCodes = this.amendInternalCodes.filter((el, i, a) => i === a.indexOf(el))

    }

    getOtherCodesConfig() {
        this.getOtherCodeConfig = {
            "otherCodes": []
        }
        let valueOther = this.vehicleInfo.savedConfig;
        if ((JSON.parse(valueOther).otherCodes != undefined) && (JSON.parse(valueOther).otherCodes != null)) {
            JSON.parse(valueOther).otherCodes.forEach(element => {
                this.getOtherCodeConfig.otherCodes.push(element);
            });
        } for (let i in this.getOtherCodeConfig.otherCodes) {
            this.amendOtherCodes.push(this.getOtherCodeConfig.otherCodes[i]);
        }
    }

    getBaseUrl() {
        // let url = "http://localhost:8080/configurator/services/vc/configurations/propertiesfile";
        let url = "https://production.gorillas.mercedes-benz.com/prod/veh/configuration/vc/configurations/propertiesfile";
        // let url = "https://testing.gorillas.mercedes-benz.com/int/veh/configuration/vc/configurations/propertiesfile";
        this._http.get(url,this.requestOptions)
        // this._http.get('/assets/properties.json')
        .map(res => res.text()).subscribe(
                // (data) => this.baseUrl = JSON.parse(data).testBaseUrl,
                (data) => this.props = JSON.parse(data),
                err => {
                    if (err.status === 500) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;

                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 404) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 0) {
                        this.errorMessage = "Server is not accessible. Please try later. Status code :" + err.status;
                    } else {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    }
                    this.flagDictionary.loadingFlag = false;
                    this.flagDictionary.exceptionFlag = true;
                },
                () => {
                    if (this.props.internetLBUrl.includes(window.location.host)) {
                        this.baseUrl = this.props.internetApiUrl;
                    } else if (this.props.intranetLBUrl.includes(window.location.host)) {
                        this.baseUrl = this.props.intranetApiUrl;
                    } else {
                        this.baseUrl = this.props.baseUrl;
                    }

                    // Hide price for Taiwan market 

                    if (this.vehicleInfo.orderingMarket === '817' && (this.props.internetLBUrl.includes(window.location.host))) {
                        this.flagDictionary.hidePriceForTW = true;
                    } else {
                        this.flagDictionary.hidePriceForTW = false;
                    }
                    if (this.vehicleInfo.orderingMarket === '839' && (this.props.internetLBUrl.includes(window.location.host))) {
                        this.flagDictionary.hidePriceForJP = true;
                    } else {
                        this.flagDictionary.hidePriceForJP = false;
                    }

                    //AU/NZ
                    if ((this.vehicleInfo.orderingMarket === '901' || this.vehicleInfo.orderingMarket === '919') && ((this.props.internetLBUrl.includes(window.location.host)) || (this.props.intranetLBUrl.includes(window.location.host)))) {
                        this.flagDictionary.hideTdForAUNZ = true;

                    } else {
                        this.flagDictionary.hideTdForAUNZ = false;
                    }

                    if ((this.vehicleInfo.orderingMarket === '901' || this.vehicleInfo.orderingMarket === '919') && ((!(this.vehicleInfo.hookURL.includes('sapevent:CFG'))) && (this.props.internetLBUrl.includes(window.location.host)) && (!this.props.intranetLBUrl.includes(window.location.host)))) {
                        this.flagDictionary.hideTdForAUNZSO = true;

                    } else {
                        this.flagDictionary.hideTdForAUNZSO = false;
                    }


                    //Canada Changes
                    // if (( Utils.isCountryCA_N(this.vehicleInfo.orderingMarket)  || Utils.isCountryCA_T(this.vehicleInfo.orderingMarket)) && !(this.vehicleInfo.hookURL.includes('sapevent:CFG'))) {
                    if ((Utils.isCountryCA_N(this.vehicleInfo.orderingMarket) || Utils.isCountryCA_T(this.vehicleInfo.orderingMarket)) && ((this.props.internetLBUrl.includes(window.location.host)) || (this.props.intranetLBUrl.includes(window.location.host)))) {
                        this.flagDictionary.hideTdForCA = true;
                    } else {
                        this.flagDictionary.hideTdForCA = false;
                    }

                    if (this.vehicleInfo.orderingMarket === '839') {
                        this.flagDictionary.currencyFlagJP = true;
                    }
 
                    // Mexico Changes 
                    if ((Utils.isCountryMX(this.vehicleInfo.orderingMarket)) && ((!(this.vehicleInfo.hookURL.includes('sapevent:CFG'))))) {
                        // if (( Utils.isCountryMX(this.vehicleInfo.orderingMarket)) && ((!(this.vehicleInfo.hookURL.includes('sapevent:CFG'))) && (this.props.internetLBUrl.includes(window.location.host)) && (!this.props.intranetLBUrl.includes(window.location.host)))) {
                        this.flagDictionary.hideTdForMX = true;
                        this.flagDictionary.hidePriceForMX = true;
                    } else {
                        this.flagDictionary.hideTdForMX = false;
                        this.flagDictionary.hidePriceForMX = false;
                    }

                    // Egypt Changes 
                    if ((Utils.isCountryEG(this.vehicleInfo.orderingMarket)) && ((!(this.vehicleInfo.hookURL.includes('sapevent:CFG'))))) {
                        // if (( Utils.isCountryEG(this.vehicleInfo.orderingMarket)) && ((!(this.vehicleInfo.hookURL.includes('sapevent:CFG'))) && (this.props.internetLBUrl.includes(window.location.host)) && (!this.props.intranetLBUrl.includes(window.location.host)))) {
                        this.flagDictionary.hideTdForEG = true;
                    } else {
                        this.flagDictionary.hideTdForEG = false;
                    }

                    // Temp hiding local options for South Africa market
                    if (this.vehicleInfo.orderingMarket === '675' && (this.props.internetLBUrl.includes(window.location.host))) {
                        this.flagDictionary.hideLocalOptForSA = true;
                    } else {
                        this.flagDictionary.hideLocalOptForSA = false;
                    }

                    this.path = this.props.path;


                    if (this.vehicleInfo.preSeriesModeFlag === 'X') {
                        if (!(this.vehicleInfo.hookURL.includes('sapevent:CFG')) && this.validAuthToken == true) {
                            this.getSpecialModeData();
                        }
                        else if (this.vehicleInfo.hookURL.includes('sapevent:CFG')) {
                            this.getSpecialModeData();
                        }
                    }
                    else {
                        if (this.vehicleInfo.urlFlag === '0') {
                            if (!(this.vehicleInfo.hookURL.includes('sapevent:CFG')) && this.validAuthToken == true) {
                                this.getGCCData();
                            }
                            else if (this.vehicleInfo.hookURL.includes('sapevent:CFG')) {
                                this.getGCCData();
                            }
                        }
                        if (this.vehicleInfo.urlFlag === '1') {
                            if (!(this.vehicleInfo.hookURL.includes('sapevent:CFG')) && this.validAuthToken == true) {
                                this.getValidationData();
                            }
                            else if (this.vehicleInfo.hookURL.includes('sapevent:CFG')) {
                                this.getValidationData();
                            }
                        }
                        // if ((this.vehicleInfo.urlFlag === '2' || this.vehicleInfo.urlFlag === '3')) {
                            
                        //     if (!(this.vehicleInfo.hookURL.includes('sapevent:CFG')) && this.validAuthToken == true) {
                        //         this.getPPMData();
                        //     }
                        //     else if (this.vehicleInfo.hookURL.includes('sapevent:CFG')) {
                        //         this.getPPMData();
                        //     }
                        // }

                        if (this.vehicleInfo.urlFlag === '2' || this.vehicleInfo.urlFlag === '3') {
                            if (this.validAuthToken || this.vehicleInfo.hookURL.includes('sapevent:CFG')) {
                            this.getPPMData();
                        }
}
                    }

                });
    }

    getGCCData() {
        let x = window.location.search.replace(/\+/g, '%20');
    let uricomponents = decodeURIComponent(x).substring(1).split('&');
    for (let i = 0; i < uricomponents.length; i++) {
        let pair = uricomponents[i].split('=');
    if (pair[0] === 'authToken'){
            let accesstokenkey = pair[1];
       
    this.headerOptions = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization-Token': this.encryptedToken,
        'parturl': this.parturl,
    }
     this.requestOptions = {
        headers: new Headers(this.headerOptions)
    };
}
    }  
    //SWT
    if(this.headerOptions==undefined){     
    const headerOptions = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization-Token': this.encryptedToken,
        }
         this.requestOptions = {
            headers: new Headers(headerOptions)
        };
    }


        let url = this.baseUrl + this.path + 'new' + (window.location.search).replace(/'/g, '"').replace(/(?:\r\n|\r|\n)/g, '').replace(/[\[\]']+/g,'');
        this._http.get(url,this.requestOptions)
            // this._http.get('./assets/SWTData.json')
            .map(res => res.text())
            .subscribe(
                (data) => {
                    this.data = (JSON.parse(data));
                    // set configuration ID for new/analysis API
                    this.intialConfigurationId = this.data.configurationId;
                    // this.configurationId = this.data.configurationId;
                    this.allPackageOptions = this.data.localPackagesList.concat(this.data.packages);
                    this.commonDataService.notifyAllPackageOptionsItem([this.allPackageOptions]);
                },

                err => {
                    if (err.status === 500) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 404) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        }
                        else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        }
                        else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 0) {
                        this.errorMessage = "Server is not accessible. Please try later. Status code :" + err.status;
                    } else {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    }

                    this.flagDictionary.loadingFlag = false;
                    this.flagDictionary.exceptionFlag = true;
                },
                () => {
                    this.sortingService.sortCodes(this.data.color, true)
                    this.sortingService.sortCodes(this.data.additionalColor, true)
                    this.sortingService.sortCodes(this.data.rim, true)
                    this.sortingService.sortCodes(this.data.trim, true)
                    this.sortingService.sortCodes(this.data.facOptions, true)
                    this.sortingService.sortCodes(this.data.options, true)
                    this.sortingService.sortCodes(this.data.upholstery, true)
                    this.sortingService.sortCodes(this.data.stdOpt, true)
                    this.sortingService.sortCodes(this.data.technicalDataItems, false)
                    this.sortingService.sortCodes(this.data.packages, true)
                    this.sortingService.sortCodes(this.data.localPackagesList, true)

                    this.flagDictionary.dataFlag = true;
                    this.hiddenOptions = this.data.hiddenOptions;
                    this.gccInitialInternalCodes = this.data.internalOptions;
                    this.gccInitialHiddenOptions = _.cloneDeep(this.data.hiddenOptions);
                    this.gccInternalCodes = this.data.internalOptions;
                    this.gccInternalCodesAccept = this.gccInternalCodes;

                    //japan
                    this.checkOptionsLength(this.data);
                    //For SA market only until visibility is decided
                    if (this.flagDictionary.hideLocalOptForSA) {
                        this.data.options = [];
                    }
                    this.settempStdFlag();

                },
            );
            
    }

    getGCCDataSWT() {
        let url = this.baseUrl + this.path + 'new' + (window.location.search).replace(/'/g, '"').replace(/(?:\r\n|\r|\n)/g, '').replace(/[\[\]']+/g,'');      
        this._http.get(url,this.requestOptions)
            // this._http.get('./assets/SWTData.json')
            .map(res => res.text())
            .subscribe(
                (data) => {
                    this.data = (JSON.parse(data));
                    this.configurationId = this.data.configurationId;
                    this.allPackageOptions = this.data.localPackagesList.concat(this.data.packages);
                    this.commonDataService.notifyAllPackageOptionsItem([this.allPackageOptions]);
                },

                err => {
                    if (err.status === 500) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 404) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        }
                        else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        }
                        else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 0) {
                        this.errorMessage = "Server is not accessible. Please try later. Status code :" + err.status;
                    } else {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    }

                    this.flagDictionary.loadingFlag = false;
                    this.flagDictionary.exceptionFlag = true;
                },
                () => {
                    this.sortingService.sortCodes(this.data.color, true)
                    this.sortingService.sortCodes(this.data.additionalColor, true)
                    this.sortingService.sortCodes(this.data.rim, true)
                    this.sortingService.sortCodes(this.data.trim, true)
                    this.sortingService.sortCodes(this.data.facOptions, true)
                    this.sortingService.sortCodes(this.data.options, true)
                    this.sortingService.sortCodes(this.data.upholstery, true)
                    this.sortingService.sortCodes(this.data.stdOpt, true)
                    this.sortingService.sortCodes(this.data.technicalDataItems, false)
                    this.sortingService.sortCodes(this.data.packages, true)
                    this.sortingService.sortCodes(this.data.localPackagesList, true)

                    this.flagDictionary.dataFlag = true;
                    this.hiddenOptions = this.data.hiddenOptions;
                    this.gccInitialInternalCodes = this.data.internalOptions;
                    this.gccInitialHiddenOptions = _.cloneDeep(this.data.hiddenOptions);
                    this.gccInternalCodes = this.data.internalOptions;
                    this.gccInternalCodesAccept = this.gccInternalCodes;

                    //japan
                    this.checkOptionsLength(this.data);
                    //For SA market only until visibility is decided
                    if (this.flagDictionary.hideLocalOptForSA) {
                        this.data.options = [];
                    }
                    this.settempStdFlag();
                    

                },
            );

            
        
    }


    settempStdFlag() {
        //factory options
        for (let h = 0; h < this.data.facOptions.length; h++) {
            if (this.data.facOptions[h].selected) {
                this.data.facOptions[h].tempStdFlag = true;
            } else {
                this.data.facOptions[h].tempStdFlag = false;
            }
        }

        //localoptions 
        for (let h = 0; h < this.data.options.length; h++) {
            if (this.data.options[h].selected) {
                this.data.options[h].tempStdFlag = true;
            } else {
                this.data.options[h].tempStdFlag = false;
            }
        }

        //package options
        for (let h = 0; h < this.data.packages.length; h++) {
            if (this.data.packages[h].selected) {
                this.data.packages[h].tempStdFlag = true;
            } else {
                this.data.packages[h].tempStdFlag = false;
            }
        }

        //localpackages
        for (let h = 0; h < this.data.localPackagesList.length; h++) {
            if (this.data.localPackagesList[h].selected) {
                this.data.localPackagesList[h].tempStdFlag = true;
            } else {
                this.data.localPackagesList[h].tempStdFlag = false;
            }
        }

    }

    getGCCDataForLang() {
        let windowURL = (window.location.search);
        let langFirst = windowURL.search(/language/i);
        let subLang = windowURL.substr(langFirst, 11);
        if (this.lang === undefined)
            this.lang = "en";
        let replacedLang = "language=" + this.lang
        let changedURL = windowURL.replace(subLang, replacedLang);
        let url = this.baseUrl + this.path + 'new' + changedURL.replace(/'/g, '"').replace(/(?:\r\n|\r|\n)/g, '').replace(/[\[\]']+/g,'');
        this._http.get(url, this.requestOptions)
            .map(res => res.text())
            .subscribe(
                (data) => this.dataLang = (JSON.parse(data)),
                err => {
                    if (err.status === 500) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 404) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        }
                        else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        }
                        else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 0) {
                        this.errorMessage = "Server is not accessible. Please try later. Status code :" + err.status;
                    } else {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    }
                    this.flagDictionary.loadingFlag = false;
                    this.flagDictionary.exceptionFlag = true;
                },
                () => {
                    this.sortingService.sortCodes(this.data.color, true)
                    this.sortingService.sortCodes(this.data.additionalColor, true)
                    this.sortingService.sortCodes(this.data.rim, true)
                    this.sortingService.sortCodes(this.data.trim, true)
                    this.sortingService.sortCodes(this.data.facOptions, true)
                    this.sortingService.sortCodes(this.data.options, true)
                    this.sortingService.sortCodes(this.data.upholstery, true)
                    this.sortingService.sortCodes(this.data.stdOpt, true)
                    this.sortingService.sortCodes(this.data.technicalDataItems, false)
                    this.sortingService.sortCodes(this.data.packages, true)
                    this.sortingService.sortCodes(this.data.localPackagesList, true)

                    //For SA market only until visibility is decided
                    if (this.flagDictionary.hideLocalOptForSA) {
                        this.data.options = [];
                    }
                    //japan
                    this.checkOptionsLength(this.data);
                    this.settempStdFlag();

                    this.dispatchDescriptions();

                    this.flagDictionary.dataFlag = true;
                },
            );
           
    }

    dispatchPackagedEquipmentList(dataPackagedEquipmentList, dataLangPackagedEquipmentList) {
        for (let y in dataPackagedEquipmentList) {
            for (let z in dataLangPackagedEquipmentList) {
                if (dataPackagedEquipmentList[y].code === dataLangPackagedEquipmentList[z].code) {
                    dataPackagedEquipmentList[y].description = dataLangPackagedEquipmentList[z].description;
                }
            }
        }
    }

    dispatchDescriptions() {

        //Available languages drop down values update
        this.data.availableLanguages = this.dataLang.availableLanguages;

        //color
        for (let i in this.data.color) {
            for (let j in this.dataLang.color) {
                if (this.data.color[i].code === this.dataLang.color[j].code) {
                    this.data.color[i].description = this.dataLang.color[j].description;
                }
            }
        }

        //additional color
        for (let i in this.data.additionalColor) {
            for (let j in this.dataLang.additionalColor) {
                if (this.data.additionalColor[i].code === this.dataLang.additionalColor[j].code) {
                    this.data.additionalColor[i].description = this.dataLang.additionalColor[j].description;
                }
            }
        }

        //trim
        for (let i in this.data.trim) {
            for (let j in this.dataLang.trim) {
                if (this.data.trim[i].code === this.dataLang.trim[j].code) {
                    this.data.trim[i].description = this.dataLang.trim[j].description;
                }
            }
        }

        //rim
        for (let i in this.data.rim) {
            for (let j in this.dataLang.rim) {
                if (this.data.rim[i].code === this.dataLang.rim[j].code) {
                    this.data.rim[i].description = this.dataLang.rim[j].description;
                }
            }
        }
        //upholstery
        for (let i in this.data.upholstery) {
            for (let j in this.dataLang.upholstery) {
                if (this.data.upholstery[i].code === this.dataLang.upholstery[j].code) {
                    this.data.upholstery[i].description = this.dataLang.upholstery[j].description;
                }
            }
        }


        //factory options
        for (let i in this.data.facOptions) {
            for (let j in this.dataLang.facOptions) {
                if (this.data.facOptions[i].code === this.dataLang.facOptions[j].code) {
                    this.data.facOptions[i].description = this.dataLang.facOptions[j].description;
                }
            }
        }

        //local options
        for (let i in this.data.options) {
            for (let j in this.dataLang.options) {
                if (this.data.options[i].code === this.dataLang.options[j].code) {
                    this.data.options[i].description = this.dataLang.options[j].description;
                }
            }
        }

        // package options
        for (let i in this.data.packages) {
            for (let j in this.dataLang.packages) {
                if (this.data.packages[i].code === this.dataLang.packages[j].code) {
                    this.data.packages[i].description = this.dataLang.packages[j].description;
                    this.dispatchPackagedEquipmentList(this.data.packages[i].packagedEquipmentList, this.dataLang.packages[j].packagedEquipmentList);
                }
            }
        }

        //local packages
        for (let i in this.data.localPackagesList) {
            for (let j in this.dataLang.localPackagesList) {
                if (this.data.localPackagesList[i].code === this.dataLang.localPackagesList[j].code) {
                    this.data.localPackagesList[i].description = this.dataLang.localPackagesList[j].description;
                    this.dispatchPackagedEquipmentList(this.data.packages[i].localPackagedEquipmentList, this.dataLang.packages[j].localPackagedEquipmentList);
                }
            }
        }

        //standard options
        for (let i in this.data.stdOpt) {
            for (let j in this.dataLang.stdOpt) {
                if (this.data.stdOpt[i].code === this.dataLang.stdOpt[j].code) {
                    this.data.stdOpt[i].description = this.dataLang.stdOpt[j].description;
                }
            }
        }

        //technical data
        for (let i in this.data.technicalDataItems) {
            for (let j in this.dataLang.technicalDataItems) {
                if (this.data.technicalDataItems[i].code === this.dataLang.technicalDataItems[j].code) {
                    this.data.technicalDataItems[i].description = this.dataLang.technicalDataItems[j].description;
                }
            }
        }



    }

    getLanguageForURL23() {
        let windowURL = this.vehicleInfo.savedConfig;

        let langFirst = windowURL.search(/language/i);
        let subLang = windowURL.substr(langFirst, 14);
        if (this.lang === undefined)
            this.lang = "en";
        let replacedLang = "language\":" + "\"" + this.lang.toUpperCase() + "\"";
        let changedURL = windowURL.replace(subLang, replacedLang);

        let langSecond = changedURL.search(/languageCode/i);
        let subLangCode = changedURL.substr(langSecond, 18);
        if (this.lang === undefined)
            this.lang = "en";
        let replacedLangCode = "languageCode\":" + "\"" + this.lang.toUpperCase() + "\"";
        let changedURLCode = changedURL.replace(subLangCode, replacedLangCode);

        let langThird = changedURLCode.search(/documentLanguage/i);
        let subDocLang = changedURLCode.substr(langThird, 22);
        if (this.lang === undefined)
            this.lang = "en";
        let replacedDocLang = "documentLanguage\":" + "\"" + this.lang + "\"";
        let changedURLDoc = changedURLCode.replace(subDocLang, replacedDocLang);

        return changedURLDoc;
    }

    getPPMData() {
        var savedConfig;
        console.log("this.vehicleInfo---",this.vehicleInfo);
        
        savedConfig = JSON.parse(this.vehicleInfo.savedConfig);
        savedConfig.plant = this.vehicleInfo.plant;
        savedConfig.urlFlag = this.vehicleInfo.urlFlag;
        // savedConfig.salesLevel = this.vehicleInfo.salesLevel;
        console.log("this.vehicleInfoService.savedConfig--->Payload-->",JSON.stringify(savedConfig));

        this._http.post(this.baseUrl + this.path + this.vehicleInfo.internalVehicleId, JSON.stringify(savedConfig), this.requestOptions)
            .map(res => res.text())
            .subscribe(
                (data) => {
                    this.data = (JSON.parse(data));
                    this.configurationIdAmendment = this.data.configurationId;                     
                    this.allPackageOptions = this.data.localPackagesList.concat(this.data.packages);
                    this.commonDataService.notifyAllPackageOptionsItem(this.allPackageOptions);
                },
                err => {
                    if (err.status === 500) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 404) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 0) {
                        this.errorMessage = "Server is not accessible. Please try later. Status code :" + err.status;
                    } else {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    }

                    this.flagDictionary.loadingFlag = false;
                    this.flagDictionary.exceptionFlag = true;
                },
                () => {

                    this.sortingService.sortCodes(this.data.color, true)
                    this.sortingService.sortCodes(this.data.additionalColor, true)
                    this.sortingService.sortCodes(this.data.rim, true)
                    this.sortingService.sortCodes(this.data.trim, true)
                    this.sortingService.sortCodes(this.data.facOptions, true)
                    this.sortingService.sortCodes(this.data.options, true)
                    this.sortingService.sortCodes(this.data.stdOpt, true)
                    this.sortingService.sortCodes(this.data.upholstery, true)
                    this.sortingService.sortCodes(this.data.technicalDataItems, false)
                    this.sortingService.sortCodes(this.data.packages, true)
                    this.sortingService.sortCodes(this.data.localPackagesList, true)

                    //japan
                    this.checkOptionsLength(this.data);

                    // setting hiddenOptions internalOptions during initial loading
                    this.ppmInitialHiddenOptions = _.cloneDeep(this.data.hiddenOptions);
                    this.ppmInitialInternalOptions = _.cloneDeep(this.data.internalOptions);

                    this.hiddenOptions = this.data.hiddenOptions;
                    this.internalCodes = this.data.internalOptions;
                    this.amendInternalCodes = this.data.internalOptions;

                    this.ppmInternalCodesAccept = this.data.internalOptions;                    
                    const added = this.data.validationResponse.addedCodes || [];
                    const deleted = this.data.validationResponse.deletedCodes || [];

                    if (added.length > 0 || deleted.length > 0) {
                            this.flagDictionary.displayInitialAlternative = true;
                    }


                    //For SA market only until visibility is decided
                    if (this.flagDictionary.hideLocalOptForSA) {
                        this.data.options = [];
                    }
                    this.flagDictionary.dataFlag = true;
                },
            );
            
    }

    getPPMDataSWT() {  
        const headerOptions = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization-Token': this.encryptedToken,
        }
        const requestOptions = {
            headers: new Headers(headerOptions)
        };
        this._http.post(this.baseUrl + this.path + this.vehicleInfo.internalVehicleId, this.vehicleInfo.savedConfig, requestOptions)
            .map(res => res.text())
            .subscribe(
                (data) => {
                    this.data = (JSON.parse(data));
                    this.allPackageOptions = this.data.localPackagesList.concat(this.data.packages);
                    this.commonDataService.notifyAllPackageOptionsItem(this.allPackageOptions);
                },
                err => {
                    if (err.status === 500) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 404) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 0) {
                        this.errorMessage = "Server is not accessible. Please try later. Status code :" + err.status;
                    } else {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    }

                    this.flagDictionary.loadingFlag = false;
                    this.flagDictionary.exceptionFlag = true;
                },
                () => {

                    this.sortingService.sortCodes(this.data.color, true)
                    this.sortingService.sortCodes(this.data.additionalColor, true)
                    this.sortingService.sortCodes(this.data.rim, true)
                    this.sortingService.sortCodes(this.data.trim, true)
                    this.sortingService.sortCodes(this.data.facOptions, true)
                    this.sortingService.sortCodes(this.data.options, true)
                    this.sortingService.sortCodes(this.data.stdOpt, true)
                    this.sortingService.sortCodes(this.data.upholstery, true)
                    this.sortingService.sortCodes(this.data.technicalDataItems, false)
                    this.sortingService.sortCodes(this.data.packages, true)
                    this.sortingService.sortCodes(this.data.localPackagesList, true)

                    //japan
                    this.checkOptionsLength(this.data);

                    // setting hiddenOptions internalOptions during initial loading
                    this.ppmInitialHiddenOptions = _.cloneDeep(this.data.hiddenOptions);
                    this.ppmInitialInternalOptions = _.cloneDeep(this.data.internalOptions);

                    this.hiddenOptions = this.data.hiddenOptions;
                    this.internalCodes = this.data.internalOptions;
                    this.amendInternalCodes = this.data.internalOptions;

                    this.ppmInternalCodesAccept = this.data.internalOptions;
                    if (this.data.validationResponse !== null && (this.data.validationResponse.addedCodes.length > 0 || this.data.validationResponse.deletedCodes.length > 0)) {
                        this.flagDictionary.displayInitialAlternative = true;
                    }

                    //For SA market only until visibility is decided
                    if (this.flagDictionary.hideLocalOptForSA) {
                        this.data.options = [];
                    }
                    this.flagDictionary.dataFlag = true;
                },
            );
    }

    getPPMDataForLang() {
        let changedURL = JSON.parse(this.getLanguageForURL23());
        changedURL.plant = this.vehicleInfo.plant;
        changedURL.urlFlag = "2";

        this._http.post(this.baseUrl + this.path + this.vehicleInfo.internalVehicleId, changedURL, this.requestOptions)
            .map(res => res.text())
            .subscribe(
                (data) => this.dataLang = (JSON.parse(data)),
                err => {
                    if (err.status === 500) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 404) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 0) {
                        this.errorMessage = "Server is not accessible. Please try later. Status code :" + err.status;
                    } else {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    }

                    this.flagDictionary.loadingFlag = false;
                    this.flagDictionary.exceptionFlag = true;
                },
                () => {
                    this.sortingService.sortCodes(this.data.color, true)
                    this.sortingService.sortCodes(this.data.additionalColor, true)
                    this.sortingService.sortCodes(this.data.rim, true)
                    this.sortingService.sortCodes(this.data.trim, true)
                    this.sortingService.sortCodes(this.data.facOptions, true)
                    this.sortingService.sortCodes(this.data.options, true)
                    this.sortingService.sortCodes(this.data.upholstery, true)
                    this.sortingService.sortCodes(this.data.stdOpt, true)
                    this.sortingService.sortCodes(this.data.technicalDataItems, false)
                    this.sortingService.sortCodes(this.data.packages, true)
                    this.sortingService.sortCodes(this.data.localPackagesList, true)

                    //japan
                    this.checkOptionsLength(this.data);
                    //For SA market only until visibility is decided
                    if (this.flagDictionary.hideLocalOptForSA) {
                        this.data.options = [];
                    }

                    this.dispatchDescriptions();
                    this.flagDictionary.dataFlag = true;
                },
            );
    }

    getValidationData() {
        let x = window.location.search.replace(/\+/g, '%20');
        let uricomponents = decodeURIComponent(x).substring(1).split('&');
        for (let i = 0; i < uricomponents.length; i++) {
            let pair = uricomponents[i].split('=');
        if (pair[0] === 'authToken'){
                let accesstokenkey = pair[1];
           
        this.headerOptions = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization-Token': this.encryptedToken,
            'parturl': this.parturl,
        }
         this.requestOptions = {
            headers: new Headers(this.headerOptions)
        };
    }
        }  

        //SWT
        // console.log(this.requestOptions);
        if(this.headerOptions==undefined){          
            const headerOptions = {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization-Token': this.encryptedToken,
            }
             this.requestOptions = {
                headers: new Headers(headerOptions)
            };
        }
        
        let savedConfig = JSON.parse(this.vehicleInfo.savedConfig);
        savedConfig["plant"] = this.vehicleInfo.plant
        savedConfig.urlFlag = "1";
        this._http.post(this.baseUrl + this.path + 'saved', JSON.stringify(savedConfig), this.requestOptions)
            // this._http.get('./app/services/jsons/PPM.json')
            .map(res => res.text())
            .subscribe(
                (data) => {
                    this.data = (JSON.parse(data));
                    this.storeInitialConfigurationID = this.data.configurationId
                    this.intialConfigurationId = this.data.configurationId;
                    this.configurationId = this.data.configurationId;
                    this.allPackageOptions = this.data.localPackagesList.concat(this.data.packages);
                    this.commonDataService.notifyAllPackageOptionsItem(this.allPackageOptions);
                },
                err => {
                    if (err.status === 500) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 404) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 0) {
                        this.errorMessage = "Server is not accessible. Please try later. Status code :" + err.status;
                    } else {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    }

                    this.flagDictionary.loadingFlag = false;
                    this.flagDictionary.exceptionFlag = true;
                },
                () => {

                    // this.data.color.forEach((color) => {                            
                    //     if(color.code==savedConfig.lowerPaint){                                
                    //         color.selected = true;
                    //     }else{
                    //         color.selected = false;
                    //     }                            
                    //     });   
                    //     this.data.additionalColor.forEach((additionalColor) => {                            
                    //         if(additionalColor.code==savedConfig.upperPaint){                                
                    //             additionalColor.selected = true;
                    //         }else{
                    //             additionalColor.selected = false;
                    //         }                            
                    //         }); 
                    //     this.data.upholstery.forEach((upholstery) => {                            
                    //             if(upholstery.code==savedConfig.upholstery){                                
                    //                 upholstery.selected = true;
                    //             }else{
                    //                 upholstery.selected = false;
                    //             }                            
                    //             });                             
                    //     this.data.rim.forEach((rim) => {    
                    //                 if((JSON.stringify(savedConfig.otherCodes)).includes(rim.code)){                                
                    //                     rim.selected = true;
                    //                 }else{
                    //                     rim.selected = false;
                    //                 }                            
                    //                 }); 
                    //     this.data.trim.forEach((trim) => {    
                    //                 if((JSON.stringify(savedConfig.otherCodes)).includes(trim.code)){                                
                    //                     trim.selected = true;
                    //                 }else{
                    //                     trim.selected = false;
                    //                 }                            
                    //                 });  
                    //     this.data.facOptions.forEach((facOptions) => {    
                    //                 if((JSON.stringify(savedConfig.otherCodes)).includes(facOptions.code)){                                
                    //                         facOptions.selected = true;
                    //                 }else{
                    //                         facOptions.selected = false;
                    //                     }                            
                    //                     }); 
                    //     this.data.options.forEach((options) => {    
                    //                 if((JSON.stringify(savedConfig.otherCodes)).includes(options.code)){                                
                    //                     options.selected = true;
                    //                 }else{
                    //                     options.selected = false;
                    //                 }                            
                    //                         }); 
                    //     this.data.packages.forEach((packages) => {    
                    //                 if((JSON.stringify(savedConfig.otherCodes)).includes(packages.code)){                                
                    //                     packages.selected = true;
                    //                 }else{
                    //                     packages.selected = false;
                    //                 }                            
                    //                 }); 
                    //     this.data.stdOpt.forEach((stdOpt) => {    
                    //                 if((JSON.stringify(savedConfig.otherCodes)).includes(stdOpt.code)){                                
                    //                     stdOpt.selected = true;
                    //                 }else{
                    //                     stdOpt.selected = false;
                    //                 }                            
                    //                 });
                    //     this.data.localPackagesList.forEach((localPackagesList) => {    
                    //                     if((JSON.stringify(savedConfig.otherCodes)).includes(localPackagesList.code)){                                
                    //                         localPackagesList.selected = true;
                    //                     }else{
                    //                         localPackagesList.selected = false;
                    //                     }                            
                    //                     });
                    //     this.data.technicalDataItems.forEach((technicalDataItems) => {    
                    //                         if((JSON.stringify(savedConfig.otherCodes)).includes(technicalDataItems.code)){                                
                    //                             technicalDataItems.selected = true;
                    //                         }else{
                    //                             technicalDataItems.selected = false;
                    //                         }                            
                    //                         });

                    this.sortingService.sortCodes(this.data.color, true)
                    this.sortingService.sortCodes(this.data.additionalColor, true)
                    this.sortingService.sortCodes(this.data.rim, true)
                    this.sortingService.sortCodes(this.data.trim, true)
                    this.sortingService.sortCodes(this.data.facOptions, true)
                    this.sortingService.sortCodes(this.data.options, true)
                    this.sortingService.sortCodes(this.data.upholstery, true)
                    this.sortingService.sortCodes(this.data.stdOpt, true)
                    this.sortingService.sortCodes(this.data.packages, true)
                    this.sortingService.sortCodes(this.data.localPackagesList, true)
                    this.sortingService.sortCodes(this.data.technicalDataItems, false)

                    //japan
                    this.checkOptionsLength(this.data);
                    this.hiddenOptions = this.data.hiddenOptions;
                    this.gccInitialHiddenOptions = _.cloneDeep(this.data.hiddenOptions);
                    this.gccInternalCodes = this.data.internalOptions;
                    this.gccInternalCodesAccept = this.gccInternalCodes;
                    //For SA market only until visibility is decided
                    if (this.flagDictionary.hideLocalOptForSA) {
                        this.data.options = [];
                    }
                    this.flagDictionary.dataFlag = true;
                },
            );
            
    }

    getValidationDataSWT() {
        let savedConfig = JSON.parse(this.vehicleInfo.savedConfig);
        savedConfig.urlFlag = "1";
        this._http.post(this.baseUrl + this.path + 'saved', savedConfig, this.requestOptions)
            // this._http.get('./app/services/jsons/PPM.json')
            .map(res => res.text())
            .subscribe(
                (data) => {
                    this.data = (JSON.parse(data));
                    this.allPackageOptions = this.data.localPackagesList.concat(this.data.packages);
                    this.commonDataService.notifyAllPackageOptionsItem(this.allPackageOptions);
                },
                err => {
                    if (err.status === 500) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 404) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 0) {
                        this.errorMessage = "Server is not accessible. Please try later. Status code :" + err.status;
                    } else {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    }

                    this.flagDictionary.loadingFlag = false;
                    this.flagDictionary.exceptionFlag = true;
                },
                () => {
                    this.sortingService.sortCodes(this.data.color, true)
                    this.sortingService.sortCodes(this.data.additionalColor, true)
                    this.sortingService.sortCodes(this.data.rim, true)
                    this.sortingService.sortCodes(this.data.trim, true)
                    this.sortingService.sortCodes(this.data.facOptions, true)
                    this.sortingService.sortCodes(this.data.options, true)
                    this.sortingService.sortCodes(this.data.upholstery, true)
                    this.sortingService.sortCodes(this.data.stdOpt, true)
                    this.sortingService.sortCodes(this.data.packages, true)
                    this.sortingService.sortCodes(this.data.localPackagesList, true)
                    this.sortingService.sortCodes(this.data.technicalDataItems, false)

                    //japan
                    this.checkOptionsLength(this.data);
                    this.hiddenOptions = this.data.hiddenOptions;
                    this.gccInternalCodes = this.data.internalOptions;
                    this.gccInternalCodesAccept = this.gccInternalCodes;
                    //For SA market only until visibility is decided
                    if (this.flagDictionary.hideLocalOptForSA) {
                        this.data.options = [];
                    }
                    this.flagDictionary.dataFlag = true;
                },
            );
           
    }

    getValidationDataForLang() {
        let savedConfig = JSON.parse(this.vehicleInfo.savedConfig);
        savedConfig.urlFlag = "1";

        let changedURL = JSON.parse(this.getLanguageForURL23());
        changedURL.urlFlag = "1";

        this._http.post(this.baseUrl + this.path + 'saved', changedURL, this.requestOptions)
            // this._http.get('./app/services/jsons/PPM.json')
            .map(res => res.text())
            .subscribe(
                (data) => this.dataLang = (JSON.parse(data)),
                err => {
                    if (err.status === 500) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 404) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 0) {
                        this.errorMessage = "Server is not accessible. Please try later. Status code :" + err.status;
                    } else {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    }

                    this.flagDictionary.loadingFlag = false;
                    this.flagDictionary.exceptionFlag = true;
                },
                () => {
                    this.sortingService.sortCodes(this.data.color, true)
                    this.sortingService.sortCodes(this.data.additionalColor, true)
                    this.sortingService.sortCodes(this.data.rim, true)
                    this.sortingService.sortCodes(this.data.trim, true)
                    this.sortingService.sortCodes(this.data.facOptions, true)
                    this.sortingService.sortCodes(this.data.options, true)
                    this.sortingService.sortCodes(this.data.upholstery, true)
                    this.sortingService.sortCodes(this.data.stdOpt, true)
                    this.sortingService.sortCodes(this.data.packages, true)
                    this.sortingService.sortCodes(this.data.localPackagesList, true)
                    this.sortingService.sortCodes(this.data.technicalDataItems, false)

                    //japan
                    this.checkOptionsLength(this.data);
                    //For SA market only until visibility is decided
                    if (this.flagDictionary.hideLocalOptForSA) {
                        this.data.options = [];
                    }

                    this.dispatchDescriptions();
                    this.flagDictionary.dataFlag = true;
                },
            );
    }

    getSpecialModeData() {
        let url = "https://production.gorillas.mercedes-benz.com/prod/veh/configuration/vc/configurations/SWTData";
        let props: any;
        let x = window.location.search.replace(/\+/g, '%20');
        let uricomponents = decodeURIComponent(x).substring(1).split('&');
        for (let i = 0; i < uricomponents.length; i++) {
            let pair = uricomponents[i].split('=');
        if (pair[0] === 'authToken'){
                let accesstokenkey = pair[1];
           
        this.headerOptions = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization-Token': this.encryptedToken,
            'parturl': this.parturl,
        }
         this.requestOptions = {
            headers: new Headers(this.headerOptions)
        };
    }
        }  
        //SWT
        console.log(this.requestOptions);
        if(this.headerOptions==undefined){
            const headerOptions = {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization-Token': this.encryptedToken,
            }
             this.requestOptions = {
                headers: new Headers(headerOptions)
            };
        }
 
 
        this._http.get(url,this.requestOptions)
            .map(res => res.text())
            .subscribe(
                (data) => this.data = (JSON.parse(data)),
                err => {
                    if (err.status === 500) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 404) {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    } else if (err.status === 0) {
                        this.errorMessage = "Server is not accessible. Please try later. Status code :" + err.status;
                    } else {
                        if (JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = err._body;
                        } else if (!JSON.stringify(err._body).includes('details')) {
                            this.errorMessage = (err._body);
                            if (this.errorMessage == "") {
                                this.errorMessage = "Configurator Application is Down. Please try later."
                            }
                        } else {
                            this.errorMessage = "Configurator Application is Down. Please try later."
                        }
                    }
                    this.flagDictionary.loadingFlag = false;
                    this.flagDictionary.exceptionFlag = true;
                },
                () => {
            this.flagDictionary.dataFlag = true;
},
            );
    }
    //Japan
    checkOptionsLength(data) {
        if (this.vehicleInfo.orderingMarket === '839') {
            if (data.color.length === 0) {
                this.flagDictionary.noColorOptions = true;
            }
            if (data.additionalColor.length === 0) {
                this.flagDictionary.noAdditionalColor = true;
            }
            if (data.rim.length === 0) {
                this.flagDictionary.noRimOptions = true;
            }
            if (data.trim.length === 0) {
                this.flagDictionary.noTrimOptions = true;
            }
            if (data.packages.length === 0 && data.localPackagesList.length === 0) {
                this.flagDictionary.noPackagesOptions = true;
            }
            if (data.facOptions.length === 0) {
                this.flagDictionary.noFacOptions = true;
            }
            if (data.options.length === 0) {
                this.flagDictionary.noLocalOptions = true;
            }
            if (data.upholstery.length === 0) {
                this.flagDictionary.noupholsteryOptions = true;
            }
        }
        this.cdr.tick();
    }

    fetchSavedConfig() {
        // console.log("Inside getSavedConfig method");
        // if (this.commonDataService.serviceData.internetLBUrl.includes(window.location.host)) {
        //     // console.log("Inside internetLBUrl");
        //     this.savedConfigURL = this.commonDataService.serviceData.savedConfigInternetURL;
        // } else if (this.commonDataService.serviceData.intranetLBUrl.includes(window.location.host)) {
        //     // console.log("Inside intranetLBUrl");
        //     this.savedConfigURL = this.commonDataService.serviceData.savedConfigIntranetURL;
        // }
        //   console.log("internalVehicleId in getSavedConfig",this.commonDataService.vehicleInfo.internalVehicleId);
        let getSavedConfigResponse;
        let vehicleId = this.vehicleInfoService.urlDataFromLink.internalVehicleId

        const url = `http://iaawstdi01.adc-apac.corpintra.net:8000/sap/bc/zais_ppm_config/${vehicleId}?sap-client=200`

        // console.log("headerOptions2   "+JSON.stringify(this.headerOptions2));


         this._http.get(url).subscribe(
            (response) => {
                const data = response.json();
                this.vehicleInfoService.urlDataFromLink.savedConfig = data
                 console.log(data)
            }
        )
    }

}


// WEBPACK FOOTER //
// ./src/app/services/data-loader.service.ts